import { IApiBasketInformation } from '../../api/basket/types';

export const store = {
    basketInfo: null as IApiBasketInformation | null
};
